package ca.northroot.app.data

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

actual object FirebaseConfig {
    actual fun initialize() {
        Firebase.initialize(
            options = FirebaseOptions(
                applicationId = "1:662773973691:web:cb3c069f17bb971d5e5f9e",
                apiKey = "AIzaSyB-EHKd7qTnR5Bkct0C4RvZxvnF3cQKQL8",
                databaseUrl = "https://northroot-app.firebaseio.com",
                projectId = "northroot-app",
                storageBucket = "northroot-app.firebasestorage.app",
                gcmSenderId = "662773973691"
            )
        )
    }
}
